import http from './http';
import type {
  TransferRequest,
  CreateTransferRequestPayload,
  TransferRequestFilter,
  TransferRequestListResponse,
} from '@/types';

export const transferRequestApi = {
  getGuestList: (params: TransferRequestFilter) =>
    http.get<TransferRequestListResponse>('/guest-business-transfer-requests', { params }).then((r) => r.data),

  getList: (params: TransferRequestFilter) =>
    http.get<TransferRequestListResponse>('/business-transfer-requests', { params }).then((r) => r.data),

  getById: (id: string) =>
    http.get<{ data: TransferRequest }>(`/business-transfer-requests/${id}`).then((r) => r.data.data),

  create: (body: CreateTransferRequestPayload) =>
    http.post<TransferRequest>('/business-transfer-requests', body).then((r) => r.data),

  update: (id: string, body: Partial<CreateTransferRequestPayload>) =>
    http.patch<TransferRequest>(`/business-transfer-requests/${id}`, body).then((r) => r.data),

  remove: (id: string) => http.delete(`/business-transfer-requests/${id}`).then((r) => r.data),
};
